export default __webpack_public_path__ + "static/media/dashboard.44dd6b69.svg";